import { mapRecordsFromServer } from 'coreOld/mappers';
import { partfinitiClient } from 'coreOld/services';
import { GetManyResponse, IRequestPayload } from 'coreOld/types';
import { getQueryString, objectKeysCamelToSnakeCase } from 'coreOld/utils';
import { IQuoteHistory } from 'partsOld/types';

export const getMany = async (
  requestPayload: IRequestPayload
): Promise<GetManyResponse<IQuoteHistory>> => {
  const { data } = await partfinitiClient.get(
    `/parts/quote-history/quote-history-items?${getQueryString(
      objectKeysCamelToSnakeCase(requestPayload)
    )}`
  );

  return mapRecordsFromServer<IQuoteHistory>(data.data, data.recordsFiltered);
};
